const modalButtons = document.querySelectorAll('.js-modal-button');
const modalCloseOverlays = document.querySelectorAll('.js-modal-close');
const modalVideos = document.querySelectorAll('.js-modal-video');
let lastFullscreenVideo = null;

const resetButtons = () => {
    modalButtons.forEach((button) => {
        button.blur();
        button.classList.remove('is-tapped');
    });

    document.activeElement?.blur();

    setTimeout(() => {
        document.activeElement?.blur();
    }, 100);
};

const openModal = (id) => {
    const dialog = document.getElementById(id);
    const body = document.querySelector('body');

    resetButtons();
    
    if( dialog ) {
        const modal = dialog.closest('.js-modal');
        const video = dialog.querySelector('.js-modal-video');
        const button = document.querySelector(`.js-modal-button[aria-controls="${id}"]`)

        if( modal ) {
            modal.hidden = false;
            modal.classList.add('active-dialog');
            body.classList.add('modal-open');
        }
        if( video ) {
            video.play().catch(() => {});
        } else {
            dialog.focus();
        }
    }
};

const closeModal = (overlay) => {
    const modal = overlay.closest('.js-modal');
    const dialog = modal.querySelector('.js-modal-dialog');
    const body = document.querySelector('body');

    if( dialog ) {
        const id = dialog.id;
        const button = document.querySelector(`.js-modal-button[aria-controls="${id}"]`)
        const video = dialog.querySelector('.js-modal-video');

        if( modal ) {
            modal.hidden = true;
            modal.classList.remove('active-dialog');
            body.classList.remove('modal-open');
            dialog.blur();
        }
        if( video ) {
            video.pause();
            video.blur();
        }
    }

    resetButtons();
}

const escModal = (event) => {
    const body = document.querySelector('body');
    if (event.key === 'Escape' && body.classList.contains('modal-open') ) {
        event.preventDefault();
        const activeDialog = document.querySelector('.active-dialog');
        const modal = activeDialog.closest('.js-modal');
        const overlay = modal.querySelector('.js-modal-close');
        closeModal(overlay);
        return;
    }
}

const exitVideoFullScreen = (video) => {
    const modal = video.closest('.js-modal');
    const overlay = modal.querySelector('.js-modal-close');
    closeModal(overlay);
}

document.addEventListener('DOMContentLoaded', () => {
    modalButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            const button = event.currentTarget;
            const modalId = button.getAttribute('aria-controls');

            button.classList.add('is-tapped');
            button.blur();

            openModal(modalId);
        });
    })

    modalCloseOverlays.forEach((overlay) => {
        overlay.addEventListener('click', (event) => {
            closeModal(overlay)
        })
    })

    modalVideos.forEach((video) => {
        video.addEventListener('webkitbeginfullscreen', () => {
            lastFullscreenVideo = video;
        });

        video.addEventListener('webkitendfullscreen', () => {
            exitVideoFullScreen(video);
            lastFullscreenVideo = null;
        });
    })
});

document.addEventListener('keydown', (event) => {
    escModal(event)
});

document.addEventListener('fullscreenchange', () => {
    const fullscreenElement = document.fullscreenElement;

    if (fullscreenElement) {
        lastFullscreenVideo =
        fullscreenElement.tagName === 'VIDEO'
            ? fullscreenElement
            : fullscreenElement.querySelector?.('video') || null;
    } else if (lastFullscreenVideo) {
        exitVideoFullScreen(lastFullscreenVideo);
        lastFullscreenVideo = null;
    }
});

document.addEventListener('webkitfullscreenchange', () => {
  const fullscreenElement = document.webkitFullscreenElement;

  if (fullscreenElement) {
    lastFullscreenVideo =
      fullscreenElement.tagName === 'VIDEO'
        ? fullscreenElement
        : fullscreenElement.querySelector?.('video') || null;
  } else if (lastFullscreenVideo) {
    exitVideoFullScreen(lastFullscreenVideo);
    lastFullscreenVideo = null;
  }
});